import "../sass/style.sass"

import "./video-banner"